module.exports = __webpack_public_path__ + "img/table.667e6a93.svg";